import { createError } from '#app'

export function requireContentfulEntry<T>(
  entry: T | null | undefined,
  statusMessage = 'Page Not Found',
): T {
  if (entry) return entry

  throw createError({
    statusCode: 404,
    statusMessage,
    fatal: true,
  })
}
